export class Excheck {
  hoId: string;
  invoices: any[];
}
